'use es6';

import { combineReducers } from 'redux';
import Achievement from './Achievement';
import Auth from './Auth';
import AvailableLanguages from './AvailableLanguages';
import ContentById from './ContentById';
import Filters from './Filters';
import Lessons from './Lessons';
import Tracks from './Tracks';
import GettingStarted from './GettingStarted';
import AcademyToSoftware from './AcademyToSoftware';
import Accounts from './Accounts';
import Wizard from './Wizard';
import Products from './Products';
export default combineReducers({
  accounts: Accounts,
  achievement: Achievement,
  auth: Auth,
  availableLanguages: AvailableLanguages,
  contentById: ContentById,
  filters: Filters,
  lessons: Lessons,
  tracks: Tracks,
  gettingStarted: GettingStarted,
  academyToSoftware: AcademyToSoftware,
  wizard: Wizard,
  products: Products
});